//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'DanielECG',
  data() {
    return {
      form:{
        tachycardia:'0',
        noRbbb:'0',
        rbbb:'0',
        q:'0',
        t:'0',
        v:'0',
        v1:'',
        v2:'',
        v3:'',
      },
      dataList1: [
        { value: "1", name: "1~2 mm" },
        { value: "2", name: "＞2mm" },
      ],
      dataList2: [
        { value: "1", name: "<1 mm" },
        { value: "2", name: "1~2 mm" },
        { value: "3", name: "＞2mm" },
      ],
      dataList3: [
        { value: "1", name: "<1 mm" },
        { value: "2", name: "1~2 mm" },
        { value: "3", name: "＞2mm" },
      ],
      hasScore:false,
      disabled:false,
      descTxt:'',
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key]=='---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '...'
      } else {
        let result = form.tachycardia * 2 + form.noRbbb * 2 + form.rbbb * 3 + form.q * 1 + form.t * 2 + form.v * 4 + form.v1 + form.v2 + form.v3
        self.hasScore = true
        if (result>=10) {
          self.descTxt = '由PE引起的严重肺动脉高压'
        } else {
          self.descTxt = ''
        }
        return String(result)
      }
    }
  },
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Card/DanielECG.vue